import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import { FaBarsStaggered, FaDollarSign } from "react-icons/fa6";
import { LuUsers } from "react-icons/lu";
import { toast } from "react-toastify";
import axios from "axios";
import { TiTickOutline } from "react-icons/ti";
import { IoSearchOutline } from "react-icons/io5";
import { HiChevronDown } from "react-icons/hi2";
import { FaHandHoldingDollar } from "react-icons/fa6";
import { SiBlockchaindotcom } from "react-icons/si";
import AdminNav from "./AdminNav";

import Loader from "../../components/Loader";
import { PiHandWithdrawFill } from "react-icons/pi";
import { BsGraphUpArrow } from "react-icons/bs";
import { motion } from "framer-motion";
import Swal from "sweetalert2";
import { formatNumber } from "../../utils/formateNum";
import { Button, Dropdown, Menu } from "antd";
import { IoIosArrowDown } from "react-icons/io";
const AdminDash = () => {
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [allTransactions, setAllTransactions] = useState([]);
  const [allWithdraws, setAllWithdraws] = useState([]);
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const [expandedRow, setExpandedRow] = useState(null);
  const token = localStorage.getItem("admintoken");
  const [allProfits, setAllProfits] = useState([]);
  const [currencySummary, setCurrencySummary] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const [selectedCurrencyAmount, setSelectedCurrencyAmount] = useState(0);
  const [cryptoSummary, setCryptoSummary] = useState([]);
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [selectedAssetAmount, setSelectedAssetAmount] = useState(0);
  const [selectedWithdrawAsset, setSelectedWithdrawAsset] = useState(null);
  const [selectedWithdrawAssetAmount, setSelectedWithdrawAssetAmount] =
    useState(0);
  // Toggle row expansion
  const toggleRow = (userId) => {
    setExpandedRow((prev) => (prev === userId ? null : userId));
  };

  // Toggle sidebar
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  // Fetch all users
  const getAllUsersData = async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API}/api/v1/auth/m-users`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (data?.success) {
        setUsers(data.users);
        setFilteredUsers(data.users);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Fetch all transactions
  const getAllTransactionsData = async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API}/api/v1/transaction/transactions`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (data?.success) {
        setAllTransactions(data.transactions);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Fetch withdraw requests
  useEffect(() => {
    const fetchWithdrawData = async () => {
      setLoading(true);
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API}/api/v1/withdraw/get-withdraws`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (data?.success) {
          const sortedWithdraws = data.withdrawRequests.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          setAllWithdraws(sortedWithdraws);
        } else {
          toast.error(data.message);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchWithdrawData();
  }, [token]);

  // Load users & transactions on mount
  useEffect(() => {
    getAllUsersData();
    getAllTransactionsData();
  }, [token]);

  // Filter users by search term
  useEffect(() => {
    if (!searchTerm.trim()) {
      setFilteredUsers(users);
    } else {
      const filteredData = users.filter(
        (user) =>
          user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          user.email.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredUsers(filteredData);
    }
  }, [searchTerm, users]);

  // Filter users by KYC status
  const handleStatusChange = (e) => {
    const selectedStatus = e.target.value;
    setStatus(selectedStatus);
    if (selectedStatus === "all") {
      setFilteredUsers(users);
    } else {
      const numericStatus = Number(selectedStatus);
      setFilteredUsers(
        users.filter((user) => user.kycstatus === numericStatus)
      );
    }
  };

  useEffect(() => {
    setFilteredUsers(users);
  }, [users]);

  const getKYCStatus = (kycstatus) => {
    switch (kycstatus) {
      case 0:
        return "Not Submitted";
      case 1:
        return "Pending Approval";
      case 2:
        return "Verified";
      case 3:
        return "Rejected";
      default:
        return "Unknown";
    }
  };

  const getKYCClass = (kycstatus) => {
    switch (kycstatus) {
      case 0:
        return "kyc-not-submitted";
      case 1:
        return "kyc-pending";
      case 2:
        return "kyc-verified";
      case 3:
        return "kyc-rejected";
      default:
        return "";
    }
  };

  const getUserTransactions = (userId) => {
    return allTransactions.filter(
      (transaction) => transaction.userID === userId
    );
  };

  const totalDeposit = allTransactions
    .filter(
      (t) =>
        t.currency === "USD" &&
        t.type === "Deposit" &&
        t.paymentMethod === "Fiat"
    )
    .reduce((sum, t) => sum + Number(t.amount || 0), 0);

  const totalWithdraw = allTransactions
    .filter(
      (t) =>
        t.currency === "USD" &&
        t.type === "Withdrawal" &&
        t.paymentMethod === "Fiat"
    )
    .reduce((sum, t) => sum + Number(t.amount || 0), 0);

  const totalFiatFees = allTransactions
    .filter(
      (t) =>
        [
          "Sales Fee",
          "Hedging Fee",
          "Management Fee",
          "Processing Fee",
        ].includes(t.type) && t.paymentMethod === "Fiat"
    )
    .reduce((sum, t) => sum + Number(t.amount || 0), 0);
  const totalUSDFees = allTransactions
    .filter(
      (t) =>
        t.currency === "USD" &&
        [
          "Sales Fee",
          "Hedging Fee",
          "Management Fee",
          "Processing Fee",
        ].includes(t.type) &&
        t.paymentMethod === "Fiat"
    )
    .reduce((sum, t) => sum + Number(t.amount || 0), 0);
  const pendingUSD = allTransactions
    .filter(
      (t) =>
        t.currency === "USD" &&
        t.status === 0 &&
        ["Withdrawal"].includes(t.type) &&
        t.paymentMethod === "Fiat"
    )
    .reduce((sum, t) => sum + Number(t.amount || 0), 0);

  const availableBalanceUSD = Math.max(
    0,
    totalDeposit - (totalWithdraw + totalFiatFees)
  );

  useEffect(() => {
    const fetchAllProfits = async () => {
      setLoading(true);
      try {
        // Profits
        const profitsRes = await axios.get(
          `${process.env.REACT_APP_API}/api/v1/admin/get-all-profits`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (profitsRes.data?.success) {
          const sortedProfits = profitsRes.data.result.sort(
            (a, b) => new Date(b.date) - new Date(a.date)
          );
          setAllProfits(sortedProfits);

          // Calculate total amount per currency
          const currencyTotals = {};
          sortedProfits.forEach((entry) => {
            if (!entry.currency) return;
            const amount = entry.type === "loss" ? -entry.amount : entry.amount;
            if (!currencyTotals[entry.currency])
              currencyTotals[entry.currency] = 0;
            currencyTotals[entry.currency] += amount;
          });

          const summary = Object.entries(currencyTotals).map(
            ([currency, total]) => ({
              currency,
              total,
            })
          );

          setCurrencySummary(summary);

          // Set default currency (first one)
          if (summary.length > 0) {
            setSelectedCurrency(summary[0].currency);
            setSelectedCurrencyAmount(summary[0].total);
          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchAllProfits();
  }, [token]);

  useEffect(() => {
    const cryptoTransactions = allTransactions.filter(
      (tx) => tx.paymentMethod === "Crypto"
    );

    const assetTotals = {};

    cryptoTransactions.forEach((tx) => {
      const asset = tx.asset;
      const type = tx.type?.toLowerCase();

      if (!asset || (type !== "deposit" && type !== "withdrawal")) return;

      if (!assetTotals[asset]) {
        assetTotals[asset] = {
          deposit: 0,
          withdrawal: 0,
          net: 0,
        };
      }

      if (type === "deposit") {
        assetTotals[asset].deposit += tx.amount;
      } else if (type === "withdrawal") {
        assetTotals[asset].withdrawal += tx.amount;
      }

      assetTotals[asset].net =
        assetTotals[asset].deposit - assetTotals[asset].withdrawal;
    });

    const cryptoSummarymain = Object.entries(assetTotals).map(
      ([asset, data]) => ({
        asset,
        deposit: data.deposit,
        withdrawal: data.withdrawal,
        total: data.net,
      })
    );

    setCryptoSummary(cryptoSummarymain);

    if (cryptoSummarymain.length > 0) {
      const first = cryptoSummarymain[0];
      setSelectedAsset(first.asset);
      setSelectedAssetAmount(first.total);
      setSelectedWithdrawAsset(first.asset);
      setSelectedWithdrawAssetAmount(first.withdrawal);
    }
  }, [allTransactions]);

  const profitMenu = (
    <Menu
      onClick={(e) => {
        const selected = currencySummary.find((c) => c.currency === e.key);
        setSelectedCurrency(e.key);
        setSelectedCurrencyAmount(selected?.total || 0);
      }}
    >
      {currencySummary.map((c) => (
        <Menu.Item key={c.currency}>
          {c.currency} — {c.total.toFixed(2)}
        </Menu.Item>
      ))}
    </Menu>
  );
  const cryptoDepositMenu = (
    <Menu
      onClick={(e) => {
        const selected = cryptoSummary.find((c) => c.asset === e.key);
        setSelectedAsset(e.key);
        setSelectedAssetAmount(selected?.total || 0);
      }}
    >
      {cryptoSummary.map((c) => (
        <Menu.Item key={c.asset}>{c.asset}</Menu.Item>
      ))}
    </Menu>
  );

  const cryptoWithdrawMenu = (
    <Menu
      onClick={(e) => {
        const selected = cryptoSummary.find((c) => c.asset === e.key);
        setSelectedWithdrawAsset(e.key);
        setSelectedWithdrawAssetAmount(selected?.withdrawal || 0);
      }}
    >
      {cryptoSummary.map((c) => (
        <Menu.Item key={c.asset}>{c.asset}</Menu.Item>
      ))}
    </Menu>
  );

  // Navigate or show warning if user not verified
  const checkStatusAndNavigate = async (user) => {
    if (user.kycstatus === 2) {
      navigate(`/dashboard/admin/user-details/${user._id}`);
    } else {
      Swal.fire({
        title: "User Not Verified",
        text: `${user.name} has not completed KYC. Please complete the KYC verification process.`,
        icon: "warning",
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <div className="wrapper d-flex align-items-stretch">
      {loading && <Loader />}

      <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />

      <div id="content" className="px-2">
        <button
          type="button"
          id="openSidebar"
          onClick={toggleSidebar}
          className="bars-btn"
        >
          <FaBarsStaggered />
        </button>
        <AdminNav />

        {/* Top Summary Boxes */}
        <div className="mt-3">
          <div className="boxes-main">
            <Link className="box-btn">
              <LuUsers className="box-btn-icon" />
              <h4 className="box-title">{formatNumber(users.length)}</h4>
              <p className="box-text">Total Users</p>
            </Link>

            <Link
              className="box-btn"
              to={`/dashboard/admin/trans?state=Deposit`}
            >
              <FaDollarSign className="box-btn-icon" />
              <h4 className="box-title">{formatNumber(totalDeposit)}</h4>
              <p className="box-text">Total USD Deposit</p>
            </Link>

            <Link
              className="box-btn"
              to={`/dashboard/admin/trans?state=Withdrawal`}
            >
              <FaDollarSign className="box-btn-icon" />
              <h4 className="box-title">{formatNumber(totalWithdraw)}</h4>
              <p className="box-text">Total USD Withdrawals</p>
            </Link>

            <Link
              className="box-btn"
              to={`/dashboard/admin/trans?state=Available Balance`}
            >
              <TiTickOutline className="box-btn-icon" />
              <h4 className="box-title">{formatNumber(availableBalanceUSD)}</h4>
              <p className="box-text">Available USD Balance</p>
            </Link>

            <Link className="box-btn" to={`/dashboard/admin/trans?state=Fees`}>
              <FaHandHoldingDollar className="box-btn-icon" />
              <h4 className="box-title">{formatNumber(totalUSDFees)}</h4>
              <p className="box-text">Total USD Fees</p>
            </Link>

            <Link
              className="box-btn"
              to={`/dashboard/admin/trans?state=Withdrawal&status=Pending`}
            >
              <PiHandWithdrawFill className="box-btn-icon" />
              <h4 className="box-title">{pendingUSD}</h4>
              <p className="box-text">Pending USD Withdrawals</p>
            </Link>

            <Link className="box-btn" to={`/dashboard/admin/trans?state=Fees`}>
              <PiHandWithdrawFill className="box-btn-icon" />
              <h4 className="box-title">{formatNumber(totalFiatFees)}</h4>
              <p className="box-text">Total Fiat Fees</p>
            </Link>

            <Link className="box-btn">
              <BsGraphUpArrow className="box-btn-icon" />
              <h4 className="box-title d-flex">
                {formatNumber(selectedCurrencyAmount)}{" "}
                <div className="ms-2">
                  <Dropdown overlay={profitMenu} trigger={["click"]}>
                    <Button className="currency-select">
                      <IoIosArrowDown />
                    </Button>
                  </Dropdown>
                </div>
              </h4>
              <p className="box-text">Total Profit {selectedCurrency}</p>
            </Link>
            <Link className="box-btn">
              <SiBlockchaindotcom className="box-btn-icon" />
              <h4 className="box-title d-flex">
                {formatNumber(selectedAssetAmount)}{" "}
                <div className="ms-2">
                  <Dropdown overlay={cryptoDepositMenu} trigger={["click"]}>
                    <Button className="currency-select">
                      <IoIosArrowDown />
                    </Button>
                  </Dropdown>
                </div>
              </h4>
              <p className="box-text">Total deposited {selectedAsset} amount</p>
            </Link>
            <Link className="box-btn">
              <SiBlockchaindotcom className="box-btn-icon" />
              <h4 className="box-title d-flex">
                {formatNumber(selectedWithdrawAssetAmount)}{" "}
                <div className="ms-2">
                  <Dropdown overlay={cryptoWithdrawMenu} trigger={["click"]}>
                    <Button className="currency-select">
                      <IoIosArrowDown />
                    </Button>
                  </Dropdown>
                </div>
              </h4>
              <p className="box-text">
                Total withdrawal {selectedWithdrawAsset} amount
              </p>
            </Link>
          </div>
        </div>

        {/* Filters: KYC Status + Search */}
        <div className="search-add-main">
          <div className="other-filter-sub">
            <label className="bc-clr">Status</label>
            <select
              className="filter-inp"
              value={status}
              onChange={handleStatusChange}
            >
              <option value="all">All</option>
              <option value="0">Not Submitted</option>
              <option value="1">Pending</option>
              <option value="2">Verified</option>
              <option value="3">Rejected</option>
            </select>
          </div>
          <div className="search-main">
            <input
              type="text"
              className="search-inp"
              placeholder="Search users..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <div className="search-icon">
              <IoSearchOutline />
            </div>
          </div>
        </div>

        {/* Main Table */}
        <motion.div
          initial="hidden"
          animate="visible"
          exit="exit"
          transition={{ duration: 0.5, ease: "easeInOut" }}
        >
          <div className="tbl-main">
            <table className="simple-table">
              <thead>
                <tr>
                  <th></th>
                  <th>User</th>
                  <th>KYC Status</th>
                  <th>Balances</th>
                  <th>Total Deposit</th>
                  <th>Withdrawals</th>
                  <th>Profit</th>
                  <th>Fees</th>
                </tr>
              </thead>
              <tbody>
                {filteredUsers.length > 0 ? (
                  filteredUsers.map((user) => (
                    <tr key={user._id}>
                      {/* Chevron for expand/collapse */}
                      <td
                        className="chevron-cell"
                        onClick={() => toggleRow(user._id)}
                      >
                        <HiChevronDown
                          className={`chevron-icon ${
                            expandedRow === user._id ? "rotated" : ""
                          }`}
                        />
                      </td>

                      {/* User name + email */}
                      <td>
                        <button
                          onClick={() => checkStatusAndNavigate(user)}
                          className="username border-0 bg-transparent"
                        >
                          {user.name}
                        </button>
                        <p
                          className={`email ${
                            expandedRow === user._id ? "show" : ""
                          }`}
                        >
                          {user.email}
                        </p>
                      </td>

                      {/* KYC Status */}
                      <td>
                        <span
                          className={`kyc-status ${getKYCClass(
                            user.kycstatus
                          )}`}
                        >
                          {getKYCStatus(user.kycstatus)}
                        </span>
                      </td>

                      {/* Balances */}
                      <td>
                        {expandedRow === user._id && (
                          <div className="balances-container">
                            {/* If no balances */}
                            {!user.balances?.fiat?.length &&
                              !user.balances?.crypto?.length && (
                                <div className="no-balance">
                                  No Balances Available
                                </div>
                              )}

                            {/* Fiat Balances */}
                            {user.balances?.fiat?.length > 0 ? (
                              <div className="fiat-balances">
                                <h5>Fiat Balances</h5>
                                {user.balances.fiat.map((fiat, index) => (
                                  <div
                                    className="balance-item"
                                    key={`fiat-${index}`}
                                  >
                                    <span className="currency">
                                      {fiat.currency}:{" "}
                                      {formatNumber(
                                        Number(fiat.availableBalance || 0)
                                      )}
                                    </span>
                                  </div>
                                ))}
                              </div>
                            ) : (
                              <p>No Fiat Balances Found</p>
                            )}

                            {/* Crypto Balances */}
                            {user.balances?.crypto?.length > 0 ? (
                              <div className="crypto-balances">
                                <h5>Crypto Balances</h5>
                                {user.balances.crypto.map((crypto, index) => (
                                  <div
                                    className="balance-item"
                                    key={`crypto-${index}`}
                                  >
                                    <span className="asset">
                                      {crypto.asset}
                                    </span>
                                    {crypto.networks?.map(
                                      (network, netIndex) => (
                                        <div
                                          key={`network-${index}-${netIndex}`}
                                          className="network-item"
                                        >
                                          <span className="network-name">
                                            ({network.networkName}):{" "}
                                          </span>
                                          <span className="network-balance">
                                            {formatNumber(
                                              Number(
                                                network.availableBalance || 0
                                              )
                                            )}
                                          </span>
                                        </div>
                                      )
                                    )}
                                  </div>
                                ))}
                              </div>
                            ) : (
                              <p>No Crypto Balances Found</p>
                            )}
                          </div>
                        )}
                      </td>

                      {/* Total Deposit */}
                      <td>
                        {expandedRow === user._id && (
                          <div className="balances-container">
                            {(() => {
                              const deposits = getUserTransactions(
                                user._id
                              ).filter((tx) => tx.type === "Deposit");

                              const groupedDeposits = (assetKey) =>
                                deposits
                                  .filter((tx) => tx[assetKey])
                                  .reduce((result, tx) => {
                                    const key = tx[assetKey];
                                    result[key] =
                                      (result[key] || 0) +
                                      Number(tx.amount || 0);
                                    return result;
                                  }, {});

                              const fiatDeposits = groupedDeposits("currency");
                              const cryptoDeposits = groupedDeposits("asset");

                              return (
                                <div>
                                  <h5>Fiat Deposits</h5>
                                  {Object.entries(fiatDeposits).length ? (
                                    Object.entries(fiatDeposits).map(
                                      ([key, total]) => (
                                        <div className="balance-item" key={key}>
                                          {key}: {formatNumber(total)}
                                        </div>
                                      )
                                    )
                                  ) : (
                                    <p>No Fiat Deposits Found</p>
                                  )}

                                  <h5>Crypto Deposits</h5>
                                  {Object.entries(cryptoDeposits).length ? (
                                    Object.entries(cryptoDeposits).map(
                                      ([key, total]) => (
                                        <div className="balance-item" key={key}>
                                          {key}: {formatNumber(total)}
                                        </div>
                                      )
                                    )
                                  ) : (
                                    <p>No Crypto Deposits Found</p>
                                  )}
                                </div>
                              );
                            })()}
                          </div>
                        )}
                      </td>

                      {/* Total Withdrawals */}
                      <td>
                        {expandedRow === user._id && (
                          <div className="balances-container">
                            {(() => {
                              const withdrawals = getUserTransactions(
                                user._id
                              ).filter((tx) => tx.type === "Withdrawal");

                              const groupedWithdrawals = (assetKey) =>
                                withdrawals
                                  .filter((tx) => tx[assetKey])
                                  .reduce((result, tx) => {
                                    const key = tx[assetKey];
                                    result[key] =
                                      (result[key] || 0) +
                                      Number(tx.amount || 0);
                                    return result;
                                  }, {});

                              const fiatWithdrawals =
                                groupedWithdrawals("currency");
                              const cryptoWithdrawals =
                                groupedWithdrawals("asset");

                              return (
                                <div>
                                  <h5>Fiat Withdrawals</h5>
                                  {Object.entries(fiatWithdrawals).length ? (
                                    Object.entries(fiatWithdrawals).map(
                                      ([key, total]) => (
                                        <div className="balance-item" key={key}>
                                          {key}: {formatNumber(total)}
                                        </div>
                                      )
                                    )
                                  ) : (
                                    <p>No Fiat Withdrawals Found</p>
                                  )}

                                  <h5>Crypto Withdrawals</h5>
                                  {Object.entries(cryptoWithdrawals).length ? (
                                    Object.entries(cryptoWithdrawals).map(
                                      ([key, total]) => (
                                        <div className="balance-item" key={key}>
                                          {key}: {formatNumber(total)}
                                        </div>
                                      )
                                    )
                                  ) : (
                                    <p>No Crypto Withdrawals Found</p>
                                  )}
                                </div>
                              );
                            })()}
                          </div>
                        )}
                      </td>

                      {/* Profit (placeholder text) */}
                      <td>{expandedRow === user._id && "Profit"}</td>

                      {/* Total Fees */}
                      <td>
                        {expandedRow === user._id && (
                          <div className="balances-container">
                            {(() => {
                              const fees = getUserTransactions(user._id).filter(
                                (tx) =>
                                  [
                                    "Sales Fee",
                                    "Hedging Fee",
                                    "Management Fee",
                                    "Processing Fee",
                                  ].includes(tx.type)
                              );

                              const groupedFees = (assetKey) =>
                                fees
                                  .filter((tx) => tx[assetKey])
                                  .reduce((result, tx) => {
                                    const key = tx[assetKey];
                                    result[key] =
                                      (result[key] || 0) +
                                      Number(tx.amount || 0);
                                    return result;
                                  }, {});

                              const fiatFees = groupedFees("currency");
                              const cryptoFees = groupedFees("asset");

                              return (
                                <div>
                                  <h5>Fiat Fees</h5>
                                  {Object.entries(fiatFees).length ? (
                                    Object.entries(fiatFees).map(
                                      ([key, total]) => (
                                        <div className="balance-item" key={key}>
                                          {key}: {formatNumber(total)}
                                        </div>
                                      )
                                    )
                                  ) : (
                                    <p>No Fiat Fees Found</p>
                                  )}

                                  <h5>Crypto Fees</h5>
                                  {Object.entries(cryptoFees).length ? (
                                    Object.entries(cryptoFees).map(
                                      ([key, total]) => (
                                        <div className="balance-item" key={key}>
                                          {key}: {formatNumber(total)}
                                        </div>
                                      )
                                    )
                                  ) : (
                                    <p>No Crypto Fees Found</p>
                                  )}
                                </div>
                              );
                            })()}
                          </div>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8">No users found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default AdminDash;
